import {
  Box,
  Button,
  DialogContent,
  Stack,
  Typography,
  alpha,
  styled as muiStyled,
} from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const modalStyles = {
  borderRadius: '8px',
  background: abyssColors.neutral[50],
  boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.15)',
  overflow: 'hidden',
  maxWidth: '504px',
  height: '100%',
  maxHeight: '512px',
};

export const paperStyles = {
  boxShadow: 'none',
};

export const headerStyles = {
  padding: '16px 24px',
  borderBottom: `1px solid ${abyssColors.primary[100]}`,
  '& h5': {
    fontSize: '1.6rem',
    fontWeight: 500,
    lineHeight: '24px',
    color: abyssColors.primary[500],
  },
  '& button': {
    padding: 0,
  },
};

export const crossIconStyles = {
  fontSize: '2.4rem',
  color: abyssColors.primary[500],
  background: 'none',
};

export const SectionTitle = muiStyled(Typography)(() => ({
  color: abyssColors.primary[500],
  fontSize: '1.2rem',
  fontWeight: 500,
}));

export const Subtitle = muiStyled(Typography)(() => ({
  color: abyssColors.primary[300],
  fontSize: '1.2rem',
  fontWeight: 400,
}));

export const UploadCTA = muiStyled(Stack)(() => ({
  width: '120px',
  height: '70px',
  border: `1px dashed ${abyssColors.primary[200]}`,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  cursor: 'pointer',
}));

export const LineBreak = muiStyled(Box)(() => ({
  width: '100%',
  height: '1px',
  background: abyssColors.primary[200],
  margin: '16px 0px',
}));

export const ImageFrame = muiStyled(Box)(() => ({
  width: '120px',
  height: '70px',
  borderRadius: '4px',
  overflow: 'hidden',
  cursor: 'pointer',
}));
export const FooterText = muiStyled(Typography)(() => ({
  color: abyssColors.primary[500],
  fontSize: '1.2rem',
}));

type ButtonProps = {
  contained?: boolean;
};

export const ActionButton = muiStyled(Button)(({ contained }: ButtonProps) => ({
  padding: '4px 12px',
  height: '26px',
  borderRadius: '4px',
  fontSize: '1.2rem',
  background: contained ? abyssColors.primary[500] : abyssColors.neutral[50],
  color: contained ? abyssColors.neutral[50] : abyssColors.primary[500],
  fontWeight: 600,
  boxShadow: 'none',
  textTransform: 'none',
  ...(contained ? {} : { border: `1px solid ${abyssColors.primary[500]} !important` }),
}));

export const SelectedOverlay = muiStyled(Stack)(() => ({
  width: '120px',
  height: '70px',
  position: 'absolute',
  background: `linear-gradient(0deg, ${alpha(abyssColors.secondary[500], 0.5)} 0%, ${alpha(
    abyssColors.secondary[500],
    0.5
  )} 100%)`,
  borderRadius: '4px',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const SelectionDialogContent = muiStyled(DialogContent)(() => ({
  padding: '16px 24px',
  borderBottom: `1px solid ${abyssColors.primary[100]}`,
  height: '398px',
  overflowY: 'auto',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
}));

export const SelectionDialogActions = muiStyled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: '16px',
  paddingLeft: '24px',
}));

export const PlaceholderText = muiStyled(Typography)(() => ({
  fontSize: '1.2rem',
  color: abyssColors.primary[300],
}));
